// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'rhreu_en',
  de = 'rhreu_de',
  fr = 'rhreu_fr',
  es = 'rhreu_es',
}
